export default "__VITE_ASSET__Dx_yK5ym__"